/* eslint-disable no-console */
import { Middleware } from 'redux';
import { logsHelper } from 'helpers';
import { ERROR_ACTION_TYPE_POSTFIX } from './constants';
import { BasketErrorModel } from 'models/Errors';


export const errorActionLoggingMiddleware: Middleware = () => next => async action => {
    if (action.type?.endsWith(ERROR_ACTION_TYPE_POSTFIX) && action.error) {
        console.error('Error action was dispatched:', action);
        await logsHelper.error(new BasketErrorModel('Saga failed', undefined, action.type, undefined, action.error));
    }

    return next(action);
};